import inMemoryJwt from "../../../auth/inMemoryJwt";
import { urlServer } from "../../../config/GlobalConstant";
import localStorage from "../../../utils/hooks/useLocalStorage";
import { appendMessage, setConversationEntity, setConversationMessage, setMessageNotSeen, setMessagesNotSeen, setUsersChat } from "./chatSlice";

export const getConversationsFixed = () => async (dispatch, state) => {


    await fetch(`${urlServer}chats/get-conversation-list`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        },
        body: JSON.stringify({

            entityId:localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch(setUsersChat(respJson.data))
            }
        })
        .catch(error => {
            console.log()
        })



    /*  try {
         const { data } = await appApi.post("chatconversation/get-conversation", { entityId: user._id }, {
             headers: {
                 Authorization: `Bearer ${token}`
             }
         });
         dispatch(setConversationMessage({
             messages: data.data,
         }))
 
     } catch (error) {
 
     } */
}

export const getConversationFixed = (user) => async (dispatch, state) => {
    dispatch(setConversationEntity({
        user: user
    }))

    await fetch(`${urlServer}chats/get-conversation`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        },
        body: JSON.stringify({

            addressee: user._id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            var dataConversation = respJson.data
            if (respJson.success === true) {
                dispatch(setConversationMessage({
                    messages: dataConversation
                }))
            }
        })
        .catch(error => {
            console.log()
        })



    /*  try {
         const { data } = await appApi.post("chatconversation/get-conversation", { entityId: user._id }, {
             headers: {
                 Authorization: `Bearer ${token}`
             }
         });
         dispatch(setConversationMessage({
             messages: data.data,
         }))
 
     } catch (error) {
 
     } */
}

export const sendMessageFixed = ({replyMenssage, addresseeId, content, files },next) => async (dispatch, state) => {
    const formData = new FormData()
    formData.append("addresseeId", addresseeId)
    { replyMenssage && formData.append('responseToMessageId', `${replyMenssage._id}`) }

    if (content) {
        formData.append("content", content)
        formData.append('addresseeID', addresseeId)

        await fetch(`${urlServer}chats/send-message`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Authorization': `bearer ${inMemoryJwt.getToken()}`
            },
            body: formData
        })
            .then(response => response.json())
            .then(respJson => {
                const data = respJson
                dispatch(appendMessage(data.data))
                dispatch(getConversationsFixed())
            })
            .catch(() => {
               
            })
    }

    next()
}



